'use client';

import React from 'react';
import { Slide } from '@/shared/types';
import { CalendarDotsIcon } from '@phosphor-icons/react';
import dayjs from 'dayjs';

// Interfaces and types
interface DatePaneProps {
  slide: Slide;
}

// Component definition
const DatePane: React.FC<DatePaneProps> = ({ slide }) => {
  // Initialize state
  return (
    <div className='slide-boxes mini text-white'>
      <CalendarDotsIcon weight="duotone" className='w-4 h-4' />
      <span>{slide.date ? dayjs(slide.date).utc().format('MMMM D, YYYY') : 'Date not specified'}</span>
    </div>
  );
}

export default DatePane;